import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/location/sohna-road-gurugram")({
  beforeLoad: () => {
    throw redirect({ to: "/locations/sohna-road-gurugram", replace: true, statusCode: 301 });
  },
});
